import { CoordinatorService } from './coordinator.service';
import { ScriptSubset } from './script-subset';
import { SCRIPT_SELECTION_WIDGET_TYPE } from './script-types';

export class ScriptSelectionWidget {
    #coords: CoordinatorService;

    #_andSet = new Set<SCRIPT_SELECTION_WIDGET_TYPE>();
    #_orSet = new Set<SCRIPT_SELECTION_WIDGET_TYPE>();
    #_notSet = new Set<SCRIPT_SELECTION_WIDGET_TYPE>();

    constructor(
        coords: CoordinatorService,
        public type: string,
    ) {
        this.#coords = coords;
    }

    apply() {
        const stepLs: {
            operator: 'and' | 'or' | 'not';
            id: string;
        }[] = [];

        this.#_andSet.forEach((a) => stepLs.push({ operator: 'and', id: a.id }));
        this.#_orSet.forEach((a) => stepLs.push({ operator: 'or', id: a.id }));
        this.#_notSet.forEach((a) => stepLs.push({ operator: 'not', id: a.id }));

        this.#coords.selection$.search(this.type, stepLs);
    }
    and(arg: SCRIPT_SELECTION_WIDGET_TYPE | SCRIPT_SELECTION_WIDGET_TYPE[]) {
        if (!Array.isArray(arg)) arg = [arg];
        for (const a of arg) {
            if (this.type === 'subset' && !(a instanceof ScriptSubset))
                return console.error(
                    'ScriptSelectionWidget.and: all arguments must be a ScriptSubset',
                );
        }

        this.#_orSet.clear();
        arg.forEach((a) => this.#_andSet.add(a));
        return this;
    }

    or(arg: SCRIPT_SELECTION_WIDGET_TYPE | SCRIPT_SELECTION_WIDGET_TYPE[]) {
        if (!Array.isArray(arg)) arg = [arg];
        this.#_andSet.clear();
        arg.forEach((a) => this.#_orSet.add(a));
        return this;
    }
    not(arg: SCRIPT_SELECTION_WIDGET_TYPE | SCRIPT_SELECTION_WIDGET_TYPE[]) {
        if (!Array.isArray(arg)) arg = [arg];
        arg.forEach((a) => this.#_notSet.add(a));
        return this;
    }

    clear() {
        this.#_andSet.clear();
        this.#_orSet.clear();
        this.#_notSet.clear();
        return this;
    }

    log(prefix = 'SelectionWidget') {
        console.log(`${prefix}`, this);
        return this;
    }
}
